export default __webpack_public_path__ + "static/media/1_salesforce.610e3d99.svg";